import React from "react";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/noVisitAfterFirstVisitSagas";

const CustomDateRanges = () => {
  const dispatch = useDispatch();

  const { rangeOptions, selectedRangeOption } = useSelector((state) => {
    const { rangeOptions, selectedRangeOption } = state.noVisitAfterFirstVisit;
    return { rangeOptions, selectedRangeOption };
  }, shallowEqual);

  return (
    <MultiSelectDropdown
      options={rangeOptions}
      selectedFilters={selectedRangeOption}
      includeFilter={false}
      onSelectChange={(data) => dispatch(actionCreators.updateCustomRange(data))}
    />
  );
};
export default CustomDateRanges;
